import SvgIcon from './SvgIcon';

export default SvgIcon;



// WEBPACK FOOTER //
// ./assets/app/common/components/SvgIcon/index.js